import { render, staticRenderFns } from "./CloseBtn.vue?vue&type=template&id=e56281c4"
import script from "./CloseBtn.vue?vue&type=script&lang=ts"
export * from "./CloseBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports